import { render, staticRenderFns } from "./dialog-create-dynamic.vue?vue&type=template&id=d7671fa8&scoped=true"
import script from "./dialog-create-dynamic.vue?vue&type=script&lang=js"
export * from "./dialog-create-dynamic.vue?vue&type=script&lang=js"
import style0 from "./dialog-create-dynamic.vue?vue&type=style&index=0&id=d7671fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7671fa8",
  null
  
)

export default component.exports